import { request } from '@umijs/max';

export async function getGeneralSettings(options?: { [key: string]: any }) {
  return request<API.GeneralSettings>('/api/settings/general', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function updateGeneralSettings(data: API.GeneralSettings) {
  return request<API.GeneralSettings>('/api/settings/general', {
    method: 'PUT',
    data,
  });
}

export async function uploadLogo(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return request<API.GeneralSettings>('/api/settings/general/logo', {
    method: 'POST',
    data: formData,
  });
}

export async function clearLogo() {
  return request<API.GeneralSettings>('/api/settings/general/logo', {
    method: 'DELETE',
  });
}
